import { useCoreSelector } from '../../CoreStore';

import { HeaderModal } from './types';

export const useHeaderSlice = {
  getCoreBetLimitsOpen: (): boolean => {
    return useCoreSelector(({ header }) => header.betLimitsOpen);
  },
  getCoreOpenedModal: (): HeaderModal | null => {
    return useCoreSelector(({ header }) => header.openedModal);
  },
  getIsMiniLobbyOpen: (): boolean => {
    return useCoreSelector(({ header }) => header.isMiniLobbyOpen);
  },
  getIsBackToGameHidden: (): boolean => {
    return useCoreSelector(({ header }) => header.isBackToGameHidden);
  },
  getNavExpanded: (): boolean => {
    return useCoreSelector(({ header }) => header.navExpanded);
  },
  getNavForcedExpanded: (): boolean => {
    return useCoreSelector(({ header }) => header.navForcedExpanded);
  },
  getNavRoute: (): string[] => {
    return useCoreSelector(({ header }) => header.navRoute);
  },
  getNavOpen: (): boolean => {
    return useCoreSelector(({ header }) => header.navRoute.length > 0);
  },
  getNavRouteLevel: (): number => {
    return useCoreSelector(({ header }) => header.navRoute.length);
  },
  getNavRouteByLevel: (level: number): string | undefined => {
    return useCoreSelector(({ header }) => header.navRoute[level - 1]);
  },
};
